import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Label,
  Input,
} from "reactstrap";
import SingleNotification from "../../components/Notifications/SingleNotification";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { DatePicker } from "react-nice-dates";
import { sv } from "date-fns/locale";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import { postSetNotificationsToRead } from "../../actions/notificationActions";

export default function Notifications() {
  const notifications = useSelector((state) => state.notificationsReducer);
  const [notificationData, setNotificationData] = useState(
    notifications.notifications
  );
  const [filterStartDate, setFilterStartDate] = useState(null);
  const [filterEndDate, setFilterEndDate] = useState(null);
  const [showOnlyUnread, setShowOnlyUnread] = useState(false);

  const dispatch = useDispatch();
  const handleMarkAllAsRead = () => {
    let unreadNotifications = notifications.notifications.filter(
      (noti) => !noti.isSeenByMe
    );
    let listOfIdsToMarkAsRead = unreadNotifications.map((item) => {
      return item.notice.id;
    });
    dispatch(postSetNotificationsToRead(listOfIdsToMarkAsRead));
  };

  useEffect(() => {
    let tempNotifications = [...notifications.notifications];
    tempNotifications = tempNotifications.filter(
      (noti) => !noti.notice.isDeleted
    );
    tempNotifications.forEach((not) => {
      not.notice.showFrom = moment(not.notice.showFrom).format("YYYY-MM-DD");
    });
    if (showOnlyUnread) {
      tempNotifications = tempNotifications.filter(
        (noti) => noti.isSeenByMe === false
      );
    }
    if (filterStartDate) {
      tempNotifications = tempNotifications.filter(
        (noti) =>
          noti.notice.showFrom >= moment(filterStartDate).format("YYYY-MM-DD")
      );
    }
    if (filterEndDate) {
      tempNotifications = tempNotifications.filter(
        (noti) =>
          noti.notice.showFrom <= moment(filterEndDate).format("YYYY-MM-DD")
      );
    }
    tempNotifications = tempNotifications.sort(function (o1, o2) {
      return new Date(o2.notice.created) - new Date(o1.notice.created);
    });

    setNotificationData(tempNotifications);
  }, [
    showOnlyUnread,
    notifications.notifications,
    filterStartDate,
    filterEndDate,
  ]);

  if (notifications.loading) {
    return <Pacmanloader />;
  }

  return (
    <>
      <Card style={{ zIndex: "9" }}>
        <CardBody>
          <CardTitle>
            <FormattedMessage id="FilterNotifications" />
          </CardTitle>

          <Row className="px-2 py-2">
            <Col lg="2">
              <Label for="showOnlyUnreadBox">
                <FormattedMessage id="OnlyShowUnread" />
              </Label>
              <Input
                style={{ display: "flex", marginLeft: "0" }}
                name="showOnlyUnreadBox"
                type="checkbox"
                checked={showOnlyUnread}
                onChange={() => setShowOnlyUnread(!showOnlyUnread)}
              ></Input>
            </Col>

            <Col lg="2">
              <Label for="fromDate">
                <FormattedMessage id="FromDate" />
              </Label>
              <DatePicker
                name="fromDate"
                date={filterStartDate}
                onDateChange={(value) => setFilterStartDate(value)}
                locale={sv}
                format="yyyy-MM-dd"
              >
                {({ inputProps, focused }) => (
                  <input
                    className={
                      "input" +
                      (focused ? " -focused" : "") +
                      " " +
                      "date--picker"
                    }
                    {...inputProps}
                  />
                )}
              </DatePicker>
            </Col>
            <Col lg="2">
              <Label for="toDate">
                <FormattedMessage id="ToDate" />
              </Label>
              <DatePicker
                name="toDate"
                date={filterEndDate}
                onDateChange={(value) => setFilterEndDate(value)}
                locale={sv}
                format="yyyy-MM-dd"
              >
                {({ inputProps, focused }) => (
                  <input
                    className={
                      "input" +
                      (focused ? " -focused" : "") +
                      " " +
                      "date--picker"
                    }
                    {...inputProps}
                  />
                )}
              </DatePicker>
            </Col>
            <Col className="d-flex justify-content-end align-items-start">
              <Button
                outline
                name="buttonMarkAllAsRead"
                color="primary"
                onClick={() => handleMarkAllAsRead()}
              >
                <FormattedMessage id="MarkAllAsRead" />
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {notificationData.map((noti) => {
        return <SingleNotification key={noti.notice.id} notification={noti} />;
      })}
    </>
  );
}
